import { connect } from 'react-redux';
import { ComponentClass } from 'react';
import MatchList from '../../match-list';
import { AppState } from '@om-fe/core/core/types';
import { compose } from 'redux';
import preLoader from '@om-fe/core/core/bootstrap/preload';
import { MatchListItemLayout } from '../../utils/match-list.constants';
import { MatchListCommon } from '../../utils/match-list-models';
import MatchListSkeleton from '../../match-list-skeleton';
import { SessionInfoModel } from '@om-fe/models';
import { FilteredMarketGroupsOverview } from '../../utils/match-list-models';
import { PlatformTypes } from '@om-fe/utils';
import { getSpecialMatchListSliceName } from './special-match-list.utils';
import { SpecialMatchListStoreModel } from './special-match-list.constants';
import { getSpecialMatchList, removeSpecialMatchList } from './special-match-list.actions';
import { BonusType } from '../../../match-list-group/match-list-special-header';

export interface SpecialMatchListPublicProps extends MatchListCommon {
    readonly isDefault?: boolean;
    readonly isLoadingData?: boolean;
    readonly itemLayout?: MatchListItemLayout;
    readonly showMatchListHeader: boolean;
    readonly showMarketInMatchListGroupHeader: boolean;
    readonly selectGroupsOverview?: (item: string) => void;
    readonly filteredMarketGroupsOverviewList?: string[];
    readonly filteredMarketGroupsOverview?: Record<string, FilteredMarketGroupsOverview>;
    readonly isHasDrawer?: boolean;
    readonly deviceType?: PlatformTypes;
    readonly preventRedirect?: boolean;
    readonly bonusType: BonusType;
}

interface SpecialMatchListStoreProps {
    readonly sliceKey: string;
    readonly totalRecords: number;
    readonly limit: number;
    readonly ready: boolean;
    readonly isAuthenticated: boolean;
}
const SpecialMatchList: ComponentClass<SpecialMatchListPublicProps> = compose<ComponentClass<SpecialMatchListPublicProps>>(
    preLoader<SpecialMatchListPublicProps>({
        preload({ props, dispatch }) {
            const { instanceId, bonusType } = props;
            dispatch(getSpecialMatchList(instanceId, bonusType));
        },
        getReadySlice({ instanceId }: SpecialMatchListPublicProps): string {
            const slice: string = getSpecialMatchListSliceName(instanceId);

            return `${slice}.ready`;
        },
        update({ props, prevProps, dispatch }): void {
            const { instanceId, bonusType } = props;
           
            if (instanceId !== prevProps.instanceId) {
                dispatch(removeSpecialMatchList(prevProps.instanceId, bonusType));
                dispatch(getSpecialMatchList(instanceId, bonusType));
            } 
        },
        destroy({ props, dispatch }) {
            const { instanceId, bonusType } = props;
            dispatch(removeSpecialMatchList(instanceId, bonusType));
        },
        loadingAnimation: MatchListSkeleton,
    }),
    connect(
        (state: AppState, props: SpecialMatchListPublicProps): SpecialMatchListStoreProps => {
            const { instanceId } = props;
            const sliceKey: string = getSpecialMatchListSliceName(instanceId);
            const slice: SpecialMatchListStoreModel | undefined = state[sliceKey];
            const sessionInfo: SessionInfoModel | undefined = state.session && state.session.info;
            const isAuthenticated: boolean = !!(sessionInfo && sessionInfo.isAuthenticated);

            if (!slice) {
                return {
                    sliceKey,
                    totalRecords: 0,
                    limit: 0,
                    ready: false,
                    isAuthenticated,
                };
            }

            return {
                sliceKey,
                totalRecords: slice.totalRecords,
                ready: slice.ready,
                limit: slice.limit,
                isAuthenticated,
            };
        }
    ),
)(MatchList);
export default SpecialMatchList;
